import Vue from 'vue'

import MapComponent from "./components/MapComponent"


window.app = new Vue({
  el: '#map_app',
  data:{
  },
  components: {
    'map-component': MapComponent
  },
  watch: {

  },
  computed: {

  },
  methods: {
  },
  mounted() {



  }

});
